export enum QUERY_PARAMS {
  CAMPAIGN_ID = 'campaignId',
  REQUEST_ID = 'requestId',
  SIGN_IN = 'signIn',
}
